import { combineReducers } from 'redux';
// Import reducers
import table from './channels_availability_table_reducer';
import form from './channels_availability_form_reducer';

export default combineReducers({
	table,
	form
});
